import PropTypes from 'prop-types';
// material-ui
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavItem from './NavItem';
import { useGetMenuMaster } from 'api/menu';
import { useAuth } from '../../../../../contexts/AuthContext';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

export default function NavGroup({ item }) {
  const { user } = useAuth();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // Check if the entire group should be hidden for certain roles
  if (!user) return null;

  // Hide User Management group for admin users
  if (item.id === 'user-management' && user.role === 'admin') {
    return null;
  }

  // Filter children dynamically based on current user role
  const visibleChildren = (item.children || []).filter((menuItem) => {
    if (!user) return false;

    // Super admin can see everything
    if (user.role === 'super-admin') {
      return true;
    }

    // Check for super-admin only access
    if (menuItem.requiresSuperAdmin) {
      return false;
    }

    // Check for developer or super-admin access
    if (menuItem.requiresDeveloperOrSuperAdmin && user.role !== 'developer') {
      return false;
    }

    // Legacy check for kairos-card (keeping for backward compatibility)
    if (menuItem.id === 'kairos-card' && user.role !== 'developer') {
      return false;
    }

    return true;
  });

  // If no children are visible, don't render the group
  if (visibleChildren.length === 0) {
    return null;
  }

  const navCollapse = visibleChildren.map((menuItem) => {
    switch (menuItem.type) {
      case 'collapse':
        return (
          <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
            collapse - only available in paid version
          </Typography>
        );
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title &&
        drawerOpen && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color="textSecondary">
              {item.title}
            </Typography>
            {/* only available in paid version */}
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
}

NavGroup.propTypes = { item: PropTypes.object };
